export default __webpack_public_path__ + "static/media/menu.a1ba2521.svg";